import Vue from 'vue'
import Vuex from 'vuex'
import { fetch } from '../config/fetch.js'
import { ACCOUNT_USERINFO, HOT_GOODS_WORD, HOT_BRAND_WORD, SHELVES_GOODS_COUNT, CHANGE_IS_BILL, LOGO_URL, HEADER_NAME, BACK_PICTURE, BODY_ID } from './mutations-type.js'
import {  } from '../config/interface.js'

Vue.use(Vuex)
// localStorage.getItem("openPurchasingCart")
const store = new Vuex.Store({
	state: {
		userId: localStorage.getItem("userId"), //用户信息
		account: localStorage.getItem("account"),
		platformName: localStorage.getItem("platformName"),//平台名称
		openPurchasingCart: localStorage.getItem("openPurchasingCart"), //是否展示购物车  0隐藏采购车 1展示采购车
		token: localStorage.getItem("token"),
		logoPath: localStorage.getItem("logoPath"),
		hotGoodsWord: {}, //商品热搜词
		hotBrandWord: {}, //品牌热搜词
		goodsCount: '', //货架数量
		goodsCountShow: true,//是否显示数字
		appId: localStorage.getItem("appId"),
		isBill: sessionStorage.getItem('isBill'),  // 显示含税商品还是不含税商品，0-全部，2-含税 1-不含税
		colorMain: '#ffa726',
		goodsTaxDisplayType: localStorage.getItem("goodsTaxDisplayType"),
		// textData: '',
    // textDataX: false
    logoUrl: localStorage.getItem("logoUrl"),
    headerName: localStorage.getItem('headerName'),
    backPicture: localStorage.getItem('backPicture'),
    bodyId: localStorage.getItem('bodyId'),
	},
	getters: {},
	actions: {
		setUserInfo({ commit }, res) {
			localStorage.setItem("userId", res.id);
			localStorage.setItem("account", res.account);
			localStorage.setItem("token", res.token);
			localStorage.setItem("logoPath", res.logoPath);
			localStorage.setItem("appId", res.appId);
			// 存储平台名称
			localStorage.setItem('platformName', res.platformName);
			// 控制采购车的显影 openPurchasingCart    0隐藏采购车 1展示采购车
			localStorage.setItem('openPurchasingCart', res.openPurchasingCart);

			//服务类型
			localStorage.setItem("goodsTaxDisplayType", res.goodsTaxDisplayType);
			localStorage.setItem("type", res.type);

			commit(ACCOUNT_USERINFO, res);
		},
		setHotGoodsWord(context, res) {
			var url = hotWords;
			var data = {
				count: '',
				type: 1,
				userId: context.state.userId
			};
			fetch(url, data)
				.then(res => {
					context.commit(HOT_GOODS_WORD, res.data)
				});
		},
		setHotBrandWord(context, res) {
			var url = hotWords;
			var data = {
				count: '',
				type: 2,
				userId: context.state.userId
			};
			fetch(url, data)
				.then(res => {
					context.commit(HOT_BRAND_WORD, res.data)
				});
		},
		setGoodsCount(context, res) {
			var url = getGoodsCount;
			var data = {
				appId: context.state.appId,
				userId: context.state.userId
			};
			fetch(url, data)
				.then(res => {
					context.commit(SHELVES_GOODS_COUNT, res.data)
				});
		},
		/*changeIsBill({commit}, bill) {
			commit(CHANGE_IS_BILL, bill)
    }	*/
    setLogoUrl({ commit }, logoUrl) {
      commit(LOGO_URL, logoUrl)
    },
    setHeaderName({commit}, headerName){
      commit(HEADER_NAME, headerName)
    },
    setBackPicture({commit}, backPicture){
      commit(BACK_PICTURE, backPicture)
    },
    setBodyId({commit}, bodyId){
      commit(BODY_ID, bodyId)
    }
	},
	mutations: {
		[ACCOUNT_USERINFO](state, res) {
			state.userId = res.id;
			state.account = res.account;
			state.token = res.token;
			state.logoPath = res.logoPath;
			state.appId = res.appId;
      state.openPurchasingCart = res.openPurchasingCart;
		},
		[HOT_GOODS_WORD](state, res) {
			state.hotGoodsWord = res
		},
		[HOT_BRAND_WORD](state, res) {
			state.hotBrandWord = res
		},
		[SHELVES_GOODS_COUNT](state, res) {
			if (res == 0) {
				state.goodsCountShow = true;
			} else {
				state.goodsCountShow = false;
			}
			state.goodsCount = res;
		},
		// apple(state, res) {
		//   if(state.textDataX){
		//     state.textData = res;
		//   }
		//   state.textDataX = false
		// },
		[CHANGE_IS_BILL](state, data) {
			state.isBill = data;
			sessionStorage.setItem('isBill', data)
    },
    [LOGO_URL](state, data) {
      state.logoUrl = data;
      localStorage.setItem("logoUrl", data);
		},
    [HEADER_NAME](state, data) {
      state.headerName = data;
      localStorage.setItem("headerName", data);
    },
    [BACK_PICTURE](state, data) {
      state.backPicture = data;
      localStorage.setItem("backPicture", data);
    },
    [BODY_ID](state,data){
      state.bodyId = data;
      localStorage.setItem("bodyId", data);
    },
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js